<template>
  <div style="clear: left;">
    <pre>
      {{ summary }}
    </pre>
  </div>
</template>

<script>
export default {
  name: 'DailySummary',
  components: {
  },
  props: ['summary'],
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
}
</style>
